import { useCustomerStatementsDates } from '@egw/api'
import { GenericError, PageHeader } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { ListLink } from '../../components'
import { getAllStatementDates } from '../../utils'

export interface DocumentCenterDocument {
  name: string
  rank: number | null
  url: string
}

export const Statements: FC = () => {
  const { t } = useTranslation('features-documents')
  const { data, isLoading, error } = useCustomerStatementsDates()

  const statementsDates = getAllStatementDates(data)

  return (
    <>
      {isLoading ? (
        <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
          <Skeleton count={1} height="100px" className="mb-10" />
          <Skeleton count={5} height="50px" />
        </SkeletonTheme>
      ) : null}

      {!isLoading && (
        <PageHeader
          title={t(`statements.title`)}
          subtitle={t('common.title')}
          backLinkUrl={WEALTH_ROUTES.DOCUMENTS.path}
        />
      )}

      {Boolean(error) && (
        <div className="egw-container">
          <GenericError errorMessage={t('common.generic_error')} />
        </div>
      )}

      {statementsDates?.length ? (
        <div className="egw-container pt-0">
          {statementsDates.map((item) => (
            <ListLink key={item.name} to={item.url} title={item.name} />
          ))}
        </div>
      ) : (
        <div className="egw-container pt-0">
          <div className="bg-bglight text-body px-3 py-3.5">{t('statements.no_statements')}</div>
        </div>
      )}
    </>
  )
}
